import { render, staticRenderFns } from "./AnamneseCreate.vue?vue&type=template&id=552680cf&"
import script from "./AnamneseCreate.js?vue&type=script&lang=js&"
export * from "./AnamneseCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports